import render from "@in-core/incore-playbook/src/render";
import {
	updateMapConfig,
	setAllowedHazardTypes,
	updateAssetConfig,
	updateDatawolfConfig,
	updateDatawolfRsConfig,
	updateDatawolfWorkflowConfig,
	updateDatawolfRsWorkflowConfig,
	updateGlobalConfig,
	setAllowedDataTypes,
	updateHhsInfo,
	updateCgeInfo
} from "@in-core/incore-playbook/src/actions/config";

import fetch from "sync-fetch";

import aggregatedReducer from "./reducers";
import aggregatedRoutes from "./routes";
import {createTheme} from "@material-ui/core/styles";

const newTheme = createTheme({
	typography: {
		fontFamily: "Rubik",
	},
	palette: {
		primary: {
			main: "#00619D",
		},
		secondary:{
			main: "#00619D"
		}
	},
});

export default (render(aggregatedReducer, aggregatedRoutes, newTheme,
	async (store) => {
		// global setting
		const globalConfig = fetch("./config/globals.config.json").json();
		store.dispatch(updateGlobalConfig(globalConfig));

		// Map configuration for Salt Lake City
		const mapConfig = fetch("./config/map.config.json").json();
		store.dispatch(updateMapConfig(mapConfig));

		// Datawolf setting
		const datawolfConfig = fetch("./config/datawolf.config.json").json();
		store.dispatch(updateDatawolfConfig(datawolfConfig));

		const datawolfWorkflowConfig = fetch("./config/datawolfWorkflow.config.json").json();
		store.dispatch(updateDatawolfWorkflowConfig(datawolfWorkflowConfig));

		const datawolfRSConfig = fetch("./config/datawolfRS.config.json").json();
		store.dispatch(updateDatawolfRsConfig(datawolfRSConfig));

		const datawolfRSWorkflowConfig = fetch("./config/datawolfRSWorkflow.config.json").json();
		store.dispatch(updateDatawolfRsWorkflowConfig(datawolfRSWorkflowConfig));

		// decription table for CGE
		const cgeInfo = fetch("./config/cgeInfo.json").json();
		store.dispatch(updateCgeInfo(cgeInfo));

		// decription table for HHRS
		const hhsInfo = fetch("./config/hhsInfo.json").json();
		store.dispatch(updateHhsInfo(hhsInfo));

		// Asset configuration
		const assetConfig = fetch("./config/asset.config.json").json();
		store.dispatch(updateAssetConfig(assetConfig));

		// Salt Lake City supports EQ
		store.dispatch(setAllowedHazardTypes(["earthquake"]));
		store.dispatch(setAllowedDataTypes({
			building: true,
			retrofitStrategies: true,
			epf: true,
			network: true,
			socioeconomics: true
		}));
	},
	"playbook/slc/"
));


